jQuery(function ($) {

    if ( $('#js-bmi-calc').length ) {
        $('#js-bmi-calc').on('click', function(e) {
            let height = $('#js-bmi-input-height').val();
            let weight = $('#js-bmi-input-weight').val();
            if ( ! (height.length && height > 0) ) {
                let error = '身長に0以上の数値を入力してください';
                $('#js-bmi-error').text(error);
                $('#js-bmi-error').fadeIn();
            } else {
                if ( ! (weight.length && weight > 0) ) {
                    let error = '体重に0以上の数値を入力してください';
                    $('#js-bmi-error').text(error);
                    $('#js-bmi-error').fadeIn();
                } else {
                    $('#js-bmi-error').fadeOut();
                    let bmi = Math.round(weight / ((height / 100 ) ** 2));
                    $('#js-bmi').text(bmi).addClass('is-active');
                }
            }
        });
    }

});